
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";
import { toast } from "react-toastify";

const usetransferstationCategoryStore = create((set, get) => ({
    transferstationCategory: [],
    loading: false,
    error: false,
    statusFilter: "",

    fetchtransferstationCategory: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const hygieneData = await apiCall({
                url: `${API_BASE_URL1}IEMasterDetails/GetTransferStationFeedbackCategories`,
                method: "get",
                token: localStorage.getItem("token"),
            });
    
            set({ 
                transferstationCategory: Array.isArray(hygieneData) ? hygieneData : [], 
                // filteredObservations: Array.isArray(hygieneData) ? hygieneData : [],
                loading: false 
            });
    
        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            
            // Handle 404 (No Data Found) by setting an empty array
            if (error.response && error.response.status === 404) {
                set({ 
                    transferstationCategory: [], 
                    error: "No hygiene observations found.", 
                    loading: false 
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },
      // Create a New Transferstation Category with Validation Handling
        addTransferstationCategory: async (newObservation) => {
            set({ loading: true, error: null });
            try {
                const response = await axios.post(
                    `${API_BASE_URL1}IEMasterCreate/AddOrUpdateTransferStationFeedbackCategory`,
                    newObservation,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );
    
                set((state) => ({
                    transferstationCategory: [...state.transferstationCategory, response],
                    loading: false
                }));
    
                toast.success("TransferStation Feedback Categories Added successfully"); 
                return { success: true };
    
            } catch (error) {
                console.error("Error adding observation:", error.response?.data || error.message);
    
                if (error.response?.status === 400) { // Handle validation errors
                    const validationErrors = error.response.data.errors || error.response.data;
    
                    if (typeof validationErrors === "object") {
                        let errorMessages = [];
    
                        Object.keys(validationErrors).forEach((key) => {
                            if (Array.isArray(validationErrors[key])) {
                                validationErrors[key].forEach((msg) => {
                                    errorMessages.push(msg);
                                });
                            } else {
                                errorMessages.push(validationErrors[key]);
                            }
                        });
    
                        errorMessages.forEach((msg) => toast.error(msg));
                        return { success: false, errors: validationErrors };
                    }
                }
    
                // Handle general errors
                const errorMessage = error.response?.data || "Failed to add observation";
                toast.error(errorMessage);
                set({ error: errorMessage, loading: false });
    
                return { success: false, errors: { general: errorMessage } };
            }
            finally {
                set({ loading: false });
            }
        },
    
    
      

}));

export default usetransferstationCategoryStore;
